
$(document).ready(function(){
  promoPopCookie();
  newsletterPopupA11y(); // WCAG 1.3.1, 2.4.3, 4.1.2 — dialog focus trap & restore
});

function newsletterPopupA11y() {
  var $popup = $('#newsletter_popup');
  if (!$popup.length) { return; }
  var popupEl = $popup[0];
  var $modal = $popup.find('.popup_modal');
  if (!$modal.length) { return; }
  var FOCUSABLE = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var previousFocus = null;
  var trapKeydown = null;

  function visibleFocusables() {
    return $modal.find(FOCUSABLE).filter(':visible');
  }

  function activateTrap() {
    if (trapKeydown) { return; } 
    previousFocus = document.activeElement;
    var $focusables = visibleFocusables();
    var $target = $focusables.length ? $focusables.first() : $modal;
    setTimeout(function() { try { $target.trigger('focus'); } catch (_) {} }, 0);

    trapKeydown = function(e) {
      if (!$popup.is(':visible')) { return; }
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        $popup.find('.close_popup').trigger('click');
        return;
      }
      if (e.key !== 'Tab' && e.keyCode !== 9) { return; }
      var focusables = visibleFocusables();
      if (!focusables.length) { e.preventDefault(); return; }
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener('keydown', trapKeydown, true);
  }

  function deactivateTrap() {
    if (trapKeydown) {
      document.removeEventListener('keydown', trapKeydown, true);
      trapKeydown = null;
    }
    if (previousFocus && typeof previousFocus.focus === 'function') {
      try { previousFocus.focus(); } catch (_) {}
    }
    previousFocus = null;
  }
  if (typeof MutationObserver === 'function') {
    var mo = new MutationObserver(function() {
      if ($popup.is(':visible')) { activateTrap(); }
      else if (trapKeydown) { deactivateTrap(); }
    });
    mo.observe(popupEl, { attributes: true, attributeFilter: ['style'] });
  }
}  
  function promoPopCookie() {
  var promoCookie = "promo-showed";
  var promoDelay = $("#newsletter_popup").data("promo-delay");
  var promoExpiry = $("#newsletter_popup").data("promo-expiry");
  var my_setcookie = $.cookie('promo-showed');

  if ($("#newsletter_popup").data("promo-enabled")) {
    if (typeof my_setcookie != "undefined") {
      if (Cookies.get(promoCookie) !== "1") {
        setTimeout(function() {
          $('.popup_overlay').fadeIn();
          $('#newsletter_popup').fadeIn();  
        }, promoDelay);
      }
    }
  }

  $("#newsletter_popup .close_popup").click(function(e) {
    Cookies.set(promoCookie, "1", { expires: promoExpiry, path: "/" });	
    $('.popup_overlay').fadeOut();
    $('#newsletter_popup').fadeOut();
    e.preventDefault();
  });

    
  $('.popup_overlay').click(function () {
    Cookies.set(promoCookie, "1", { expires: promoExpiry, path: "/" });
	$(this).hide();
	$('#newsletter_popup').fadeOut();
	e.preventDefault();
  });
};

$(document).ready( function () {
    var $form = $('#mc-embedded-subscribe-form');
    if ( $form.length > 0 ) {
      $('form input[type="submit"]').bind('click', function ( event ) {

          if($('#mce-EMAIL').val()!=""){

            window.mc.ajaxOptions.success = function(response) {
              if(response.result == "error" ){
				var err_msg = response.msg;
				$('#mce-error-response').text(err_msg);
				$('#mce-error-response').show();
                $('#mc-embedded-subscribe-form').hide();
              }else{
        		$('#mc-embedded-subscribe-form').hide();
                $('.newsletter_text').hide();              
                $('.newsletter_success_text').fadeIn();
                $('.popup_wrapper .popup_modal .popup-body').css({"justify-content":"inherit"});
              }
			};      
          }
      });
    }  
    window.setInterval(function(){
      if($("#mce-error-response").text().indexOf("<a href") > 0) {
        var textToUpdate = $("#mce-error-response").text().slice(0,$("#mce-error-response").text().indexOf("<a href"));
        $("#mce-error-response").text(textToUpdate);
      }
    },500);
});

(function(){
  var CUSTOM_SORTS = ['in-stock-first', 'out-of-stock-first', 'size-ascending', 'size-descending'];

  var SIZE_RANK = {
    'xxxs': 0, 'xxs': 1, 'xs': 2, 's': 3, 'sm': 3, 'small': 3,
    'm': 4, 'md': 4, 'medium': 4,
    'l': 5, 'lg': 5, 'large': 5,
    'xl': 6, 'xxl': 7, '2xl': 7, '3xl': 8, 'xxxl': 8, '4xl': 9, '5xl': 10,
    'one size': 100, 'onesize': 100, 'os': 100
  };

  function sizeRank(raw){
    if(!raw){ return Number.POSITIVE_INFINITY; }
    var key = String(raw).trim().toLowerCase();
    if(key === ''){ return Number.POSITIVE_INFINITY; }
    if(Object.prototype.hasOwnProperty.call(SIZE_RANK, key)){ return SIZE_RANK[key]; }
    var num = parseFloat(key);
    if(!isNaN(num)){ return 1000 + num; }
    return Number.POSITIVE_INFINITY;
  }

  function getCustomSortFromUrl(){
    var match = location.search.match(/[?&]custom_sort=([^&]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCustomSortInUrl(value){
    var url = new URL(location.href);
    if(value){
      url.searchParams.set('custom_sort', value);
    } else {
      url.searchParams.delete('custom_sort');
    }
    window.history.replaceState({}, '', url.toString());
  }

  function isCustomSort(value){
    return CUSTOM_SORTS.indexOf(value) !== -1;
  }

  function applyCustomSort(value){
    var $grid = $('.collection-product-list .grid').first();
    if(!$grid.length){ return; }
    var $items = $grid.children('.product-block').detach();
    var arr = $items.toArray();

    arr.sort(function(a, b){
      var ad = a.dataset, bd = b.dataset;
      switch(value){
        case 'in-stock-first':
          return (parseInt(bd.sortAvailable,10)||0) - (parseInt(ad.sortAvailable,10)||0);
        case 'out-of-stock-first':
          return (parseInt(ad.sortAvailable,10)||0) - (parseInt(bd.sortAvailable,10)||0);
        case 'size-ascending':
          return sizeRank(ad.sortMinSize) - sizeRank(bd.sortMinSize);
        case 'size-descending':
          return sizeRank(bd.sortMaxSize) - sizeRank(ad.sortMaxSize);
      }
      return 0;
    });

    $grid.append(arr);
  }

  function syncDropdown(value){
    var $sel = $('select[name="sort_by"]');
    if(!$sel.length){ return; }
    if(value && $sel.find('option[value="' + value + '"]').length){
      $sel.val(value);
      if($sel.data('select2')){ $sel.trigger('change.select2'); }
    }
  }

  function init(){
    var current = getCustomSortFromUrl();
    if(current && isCustomSort(current)){
      syncDropdown(current);
      applyCustomSort(current);
    }
  }

  $(document).on('change', 'select[name="sort_by"]', function(evt){
    var value = $(this).val();
    if(isCustomSort(value)){
      evt.stopImmediatePropagation();
      setCustomSortInUrl(value);
      applyCustomSort(value);
    } else {
      setCustomSortInUrl('');
    }
  });

  function observeAjax(){
    var container = document.querySelector('[data-ajax-products]');
    if(!container || !window.MutationObserver){ return; }
    var debounceTimer = null;
    var observer = new MutationObserver(function(){
      var current = getCustomSortFromUrl();
      if(!current || !isCustomSort(current)){ return; }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function(){
        syncDropdown(current);
        applyCustomSort(current);
      }, 50);
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  $(document).ready(function(){
    init();
    observeAjax();
  });
})();

(function(){
  if('ontouchstart' in window || (navigator.maxTouchPoints||0) > 0){
    document.documentElement.classList.add('is-touch');
  }
})();

(function(){
  function buildPanel($dropdown, $select){
    var $panel = $dropdown.find('[data-custom-dropdown-panel]');
    $panel.empty();
    $select.find('option').each(function(){
      var $opt = $(this);
      var li = document.createElement('li');
      li.className = 'collection-toolbar__sort-option';
      li.setAttribute('role', 'option');
      li.setAttribute('data-value', $opt.attr('value'));
      li.setAttribute('tabindex', '0');
      li.textContent = $opt.text();
      if($opt.is(':selected')){ li.setAttribute('aria-selected', 'true'); }
      $panel.append(li);
    });
  }

  function syncLabel($dropdown, $select){
    var label = $select.find('option:selected').text() || $select.find('option').first().text();
    $dropdown.find('[data-custom-dropdown-value]').text(label);
    $dropdown.find('[data-custom-dropdown-panel] [data-value]').each(function(){
      if(this.getAttribute('data-value') === $select.val()){
        this.setAttribute('aria-selected', 'true');
      } else {
        this.removeAttribute('aria-selected');
      }
    });
  }

  function openPanel($dropdown){
    $dropdown.attr('data-open', 'true');
    $dropdown.find('[data-custom-dropdown-trigger]').attr('aria-expanded', 'true');
    $dropdown.find('[data-custom-dropdown-panel]').prop('hidden', false);
  }

  function closePanel($dropdown){
    $dropdown.attr('data-open', 'false');
    $dropdown.find('[data-custom-dropdown-trigger]').attr('aria-expanded', 'false');
    $dropdown.find('[data-custom-dropdown-panel]').prop('hidden', true);
  }

  function initDropdown(){
    var $dropdown = $('[data-custom-dropdown]').first();
    var $select = $('select[name="sort_by"]').first();
    if(!$dropdown.length || !$select.length){ return; }
    buildPanel($dropdown, $select);
    syncLabel($dropdown, $select);
  }

  $(document).on('click', '[data-custom-dropdown-trigger]', function(evt){
    evt.stopPropagation();
    var $dropdown = $(this).closest('[data-custom-dropdown]');
    if($dropdown.attr('data-open') === 'true'){
      closePanel($dropdown);
    } else {
      openPanel($dropdown);
    }
  });

  $(document).on('click', '[data-custom-dropdown-panel] [data-value]', function(){
    var value = this.getAttribute('data-value');
    var $dropdown = $(this).closest('[data-custom-dropdown]');
    var $select = $('select[name="sort_by"]').first();
    if(!$select.length){ return; }
    $select.val(value).trigger('change');
    syncLabel($dropdown, $select);
    closePanel($dropdown);
  });

  $(document).on('keydown', '[data-custom-dropdown-trigger]', function(evt){
    var $dropdown = $(this).closest('[data-custom-dropdown]');
    if(evt.key === 'ArrowDown' || evt.key === 'Enter' || evt.key === ' '){
      evt.preventDefault();
      openPanel($dropdown);
      $dropdown.find('[data-custom-dropdown-panel] [data-value]').first().focus();
    } else if(evt.key === 'Escape'){
      closePanel($dropdown);
    }
  });

  $(document).on('keydown', '[data-custom-dropdown-panel] [data-value]', function(evt){
    var $items = $(this).closest('[data-custom-dropdown-panel]').find('[data-value]');
    var idx = $items.index(this);
    if(evt.key === 'ArrowDown'){
      evt.preventDefault();
      $items.eq(Math.min(idx + 1, $items.length - 1)).focus();
    } else if(evt.key === 'ArrowUp'){
      evt.preventDefault();
      $items.eq(Math.max(idx - 1, 0)).focus();
    } else if(evt.key === 'Enter' || evt.key === ' '){
      evt.preventDefault();
      this.click();
    } else if(evt.key === 'Escape'){
      evt.preventDefault();
      var $dropdown = $(this).closest('[data-custom-dropdown]');
      closePanel($dropdown);
      $dropdown.find('[data-custom-dropdown-trigger]').focus();
    }
  });

  $(document).on('click', function(evt){
    var $dropdown = $('[data-custom-dropdown][data-open="true"]');
    if(!$dropdown.length){ return; }
    if(!$.contains($dropdown[0], evt.target)){
      closePanel($dropdown);
    }
  });

  $(document).ready(function(){
    initDropdown();
    var container = document.querySelector('[data-ajax-products]');
    if(container && window.MutationObserver){
      var observer = new MutationObserver(function(){
        var $dropdown = $('[data-custom-dropdown]').first();
        var $select = $('select[name="sort_by"]').first();
        if($dropdown.length && $select.length){ syncLabel($dropdown, $select); }
      });
      observer.observe(container, { childList: true, subtree: true });
    }
  });
})();

(function multiFilterInit(){
  var SELECTOR = '[data-multi-filter]';
  var INPUT_SELECTOR = SELECTOR + ' input[type="checkbox"]';
  var BAR_SELECTOR = '[data-applied-filters]';

  function root(){
    var $any = $(SELECTOR).first();
    if($any.length){ return $any.attr('data-filter-root'); }
    var $bar = $(BAR_SELECTOR).first();
    return $bar.length ? $bar.attr('data-filter-root') : null;
  }

  function gatherTags(){
    var tags = [];
    $(INPUT_SELECTOR + ':checked').each(function(){
      var v = this.value;
      if(v && tags.indexOf(v) === -1){ tags.push(v); }
    });
    return tags;
  }

  function getQueryParam(name){
    if(!location.search){ return null; }
    var pairs = location.search.substr(1).split('&');
    for(var i = 0; i < pairs.length; i++){
      var pair = pairs[i].split('=');
      if(decodeURIComponent(pair[0]) === name){
        return decodeURIComponent(pair[1] || '');
      }
    }
    return null;
  }

  function preservedQueryString(opts){
    opts = opts || {};
    if(!location.search){ return ''; }
    var keep = [];
    location.search.substr(1).split('&').forEach(function(pair){
      if(!pair){ return; }
      var k = pair.split('=')[0];
      if(k === 'sort_by' && opts.dropSortBy){ return; }
      if(k === 'custom_sort' && opts.dropCustomSort){ return; }
      if(k === 'sort_by' || k === 'custom_sort'){ keep.push(pair); }
    });
    return keep.length ? ('?' + keep.join('&')) : '';
  }

  function buildUrl(opts){
    var base = root();
    if(!base){ return null; }
    var tags = gatherTags();
    return base + (tags.length ? tags.join('+') : '') + preservedQueryString(opts);
  }

  function applyActiveStyling(){
    $(SELECTOR + ' .filter-checklist__label').each(function(){
      var $label = $(this);
      var checked = $label.find('input[type="checkbox"]').is(':checked');
      $label.toggleClass('is-active', checked);
    });
  }

  function defaultSortValue(){
    return $('select[name="sort_by"]').attr('data-default-sort') || 'manual';
  }

  function getActiveSort(){
    var customSort = getQueryParam('custom_sort');
    if(customSort){
      var $custOpt = $('select[name="sort_by"] option[value="' + customSort + '"]');
      return { kind: 'custom', value: customSort, label: ($custOpt.text() || customSort).trim() };
    }
    var urlSort = getQueryParam('sort_by');
    if(urlSort && urlSort !== defaultSortValue()){
      var $opt = $('select[name="sort_by"] option[value="' + urlSort + '"]');
      if($opt.length){ return { kind: 'native', value: urlSort, label: $opt.text().trim() }; }
      return { kind: 'native', value: urlSort, label: urlSort };
    }
    return null;
  }

  function resetSortUi(){
    var defVal = defaultSortValue();
    var $select = $('select[name="sort_by"]').first();
    if($select.length){
      $select.val(defVal);

      var $dropdown = $('[data-custom-dropdown]').first();
      if($dropdown.length){
        var defaultLabel = $select.find('option[value="' + defVal + '"]').text() || defVal;
        $dropdown.find('[data-custom-dropdown-value]').text(defaultLabel);
        $dropdown.find('[data-custom-dropdown-panel] [data-value]').each(function(){
          if(this.getAttribute('data-value') === defVal){
            this.setAttribute('aria-selected', 'true');
          } else {
            this.removeAttribute('aria-selected');
          }
        });
      }
    }
  }

  function chipLabelFromCheckbox(input){
    var $text = $(input).closest('label').find('.filter-checklist__text');
    return ($text.text() || input.value).trim();
  }

  function buildFilterChip(value, label){
    var $btn = $('<button type="button" class="applied-filter-chip"></button>')
      .attr('data-remove-filter', '')
      .attr('data-value', value)
      .attr('aria-label', 'Remove filter ' + label);
    $btn.append($('<span class="applied-filter-chip__text"></span>').text(label));
    $btn.append($('<span class="applied-filter-chip__x" aria-hidden="true">×</span>'));
    return $('<li class="applied-filters-bar__item"></li>').append($btn);
  }

  function buildSortChip(sortInfo){
    var sortLead = ($('select[name="sort_by"]').closest('.styled-dropdown').find('label').text() || 'Sort by').trim();
    var $btn = $('<button type="button" class="applied-filter-chip applied-filter-chip--sort"></button>')
      .attr('data-remove-sort', '')
      .attr('data-sort-kind', sortInfo.kind)
      .attr('aria-label', 'Remove sort ' + sortInfo.label);
    $btn.append($('<span class="applied-filter-chip__label"></span>').text(sortLead + ':'));
    $btn.append($('<span class="applied-filter-chip__text"></span>').text(sortInfo.label));
    $btn.append($('<span class="applied-filter-chip__x" aria-hidden="true">×</span>'));
    return $('<li class="applied-filters-bar__item applied-filters-bar__item--sort" data-sort-chip></li>').append($btn);
  }

  function rebuildBar(){
    var $bar = $(BAR_SELECTOR);
    if(!$bar.length){ return; }
    var $list = $bar.find('[data-applied-list]');
    $list.empty();

    var $checked = $(INPUT_SELECTOR + ':checked');
    $checked.each(function(){
      $list.append(buildFilterChip(this.value, chipLabelFromCheckbox(this)));
    });

    var sortInfo = getActiveSort();
    if(sortInfo){ $list.append(buildSortChip(sortInfo)); }

    var hasFilters = $checked.length > 0;
    var $clear = $bar.find('[data-clear-filters]');
    if(hasFilters){ $clear.removeAttr('hidden'); } else { $clear.attr('hidden', ''); }

    if(hasFilters || sortInfo){ $bar[0].removeAttribute('hidden'); }
    else { $bar[0].setAttribute('hidden', ''); }
  }

  function changeUrl(url){
    if(!url){ return; }
    var $ajax = $('[data-ajax-products]');
    var isAjax = $ajax.length && $ajax.data('ajax-products');
    if(!isAjax){ window.location = url; return; }

    if($(window).width() <= 930){
      $('html, body').animate({ scrollTop: $ajax.offset().top - 120 }, 600);
    }
    $ajax.css({ height: $ajax.height(), opacity: 0 });

    var transition = $ajax.css('transition-duration');
    var delay = 0;
    if(transition){
      delay = transition.indexOf('ms') > -1 ? parseInt(transition, 10) : parseFloat(transition) * 1000;
    }
    if(isNaN(delay) || delay < 0){ delay = 0; }

    setTimeout(function(){
      $.get(url, function(data){
        var $data = $('<div>').append($.parseHTML(data));
        var $products = $data.find('[data-ajax-products]').children();
        $ajax.empty().append($products).css({ height: '', opacity: '' });
        var title = $data.find('title:first').text();
        if(title){ document.title = title; }
        window.history.pushState('themeChangeUrl', title, url);
        rebuildBar();
      }).fail(function(){ window.location = url; });
    }, delay);
  }

  $(document).on('change', INPUT_SELECTOR, function(){
    applyActiveStyling();
    rebuildBar();
    changeUrl(buildUrl());
  });

  $(document).on('click', '[data-remove-filter]', function(){
    var value = $(this).attr('data-value');
    if(!value){ return; }
    $(INPUT_SELECTOR + '[value="' + value + '"]').prop('checked', false);
    applyActiveStyling();
    rebuildBar();
    changeUrl(buildUrl());
  });

  $(document).on('click', '[data-remove-sort]', function(){
    var url = buildUrl({ dropSortBy: true, dropCustomSort: true });
    if(!url){ return; }
    resetSortUi();
    rebuildBar();
    changeUrl(url);
  });

  $(document).on('click', '[data-clear-filters]', function(){
    $(INPUT_SELECTOR).prop('checked', false);
    applyActiveStyling();
    rebuildBar();
    changeUrl(buildUrl());
  });

  $(document).ready(function(){
    applyActiveStyling();
    rebuildBar();
  });
})();

(function collectionFilterPreviewInit(){
  var $container = $('[data-filter-preview]');
  if(!$container.length){ return; }

  var SIZE_RANK = {
    'xxxs': 0, 'xxs': 1, 'xs': 2, 's': 3, 'sm': 3, 'small': 3,
    'm': 4, 'md': 4, 'medium': 4,
    'l': 5, 'lg': 5, 'large': 5,
    'xl': 6, 'xxl': 7, '2xl': 7, '3xl': 8, 'xxxl': 8, '4xl': 9, '5xl': 10,
    'one size': 100, 'onesize': 100, 'os': 100
  };

  function sizeRank(raw){
    if(!raw){ return Number.POSITIVE_INFINITY; }
    var key = String(raw).trim().toLowerCase();
    if(key === ''){ return Number.POSITIVE_INFINITY; }
    if(Object.prototype.hasOwnProperty.call(SIZE_RANK, key)){ return SIZE_RANK[key]; }
    var num = parseFloat(key);
    if(!isNaN(num)){ return 1000 + num; }
    return Number.POSITIVE_INFINITY;
  }

  var URL_PARAMS = { stock: 'filter_stock', size: 'filter_size', sort: 'filter_sort' };
  var DEFAULT_SORT = 'new';
  var state = { stock: '', size: '', sort: DEFAULT_SORT };

  var NATIVE_SORT_PARAM = 'sort_by';
  var FILTER_TO_NATIVE = {
    'new': '',
    'popular': 'best-selling',
    'price-asc': 'price-ascending',
    'price-desc': 'price-descending'
  };
  var NATIVE_TO_FILTER = {
    'best-selling': 'popular',
    'price-ascending': 'price-asc',
    'price-descending': 'price-desc'
  };

  var isApplying = false;

  function $grid(){ return $('.collection-product-list .grid').first(); }
  function $cards(){ return $grid().children('.product-block'); }
  function readParam(name){
    if(!location.search){ return ''; }
    var pairs = location.search.substr(1).split('&');
    for(var i = 0; i < pairs.length; i++){
      var pair = pairs[i].split('=');
      if(decodeURIComponent(pair[0]) === name){
        return decodeURIComponent((pair[1] || '').replace(/\+/g, ' '));
      }
    }
    return '';
  }

  function hydrateStateFromUrl(){
    state.stock = readParam(URL_PARAMS.stock);
    state.size = readParam(URL_PARAMS.size);
    var sortParam = readParam(URL_PARAMS.sort);
    if(!sortParam){
      var nativeSort = readParam(NATIVE_SORT_PARAM);
      if(nativeSort && NATIVE_TO_FILTER[nativeSort]){ sortParam = NATIVE_TO_FILTER[nativeSort]; }
    }
    state.sort = sortParam || DEFAULT_SORT;

    if(state.size){
      var target = state.size.toLowerCase();
      var $opts = $container.find('[data-filter-group="size"] [data-filter-value]');
      $opts.each(function(){
        var v = this.getAttribute('data-filter-value') || '';
        if(v && v.toLowerCase() === target){ state.size = v; return false; }
      });
    }
  }

  function writeStateToUrl(){
    if(!window.history || !window.history.replaceState){ return; }
    try {
      var url = new URL(location.href);
      Object.keys(URL_PARAMS).forEach(function(key){
        var param = URL_PARAMS[key];
        if(state[key]){ url.searchParams.set(param, state[key]); }
        else { url.searchParams.delete(param); }
      });
      window.history.replaceState(window.history.state, '', url.toString());
    } catch(e){ }
  }

  function uniqueSizes(){
    var seen = {};
    var sizes = [];
    $cards().each(function(){
      var raw = this.getAttribute('data-sizes-available') || '';
      raw.split('|').forEach(function(s){
        s = s.trim();
        if(!s){ return; }
        var key = s.toLowerCase();
        if(!seen[key]){ seen[key] = true; sizes.push(s); }
      });
    });
    sizes.sort(function(a, b){
      var ra = sizeRank(a), rb = sizeRank(b);
      if(ra === rb){ return a.localeCompare(b); }
      return ra - rb;
    });
    return sizes;
  }

  function populateSizeOptions(){
    var sizes = uniqueSizes();
    $container.find('[data-filter-size-options]').each(function(){
      var $host = $(this);

      $host.find('li').not(':first').remove();
      sizes.forEach(function(s){
        var $btn = $('<button type="button" class="filter-preview__option" role="option" aria-selected="false">')
          .attr('data-filter-value', s)
          .text(s);
        $host.append($('<li>').append($btn));
      });
    });
  }

  function renderEmptyState(visibleCount){
    var $g = $grid();
    if(!$g.length){ return; }
    var $msg = $g.parent().find('.filter-preview__empty').first();
    if(visibleCount > 0){
      if($msg.length){ $msg.attr('hidden', ''); }
      return;
    }
    if(!$msg.length){
      $msg = $(
        '<div class="filter-preview__empty" role="status" aria-live="polite">' +
          '<p class="filter-preview__empty-title">No products match the current filters.</p>' +
          '<p class="filter-preview__empty-hint">Try a different size, switch off IN STOCK ONLY, or clear all filters.</p>' +
          '<button type="button" class="filter-preview__empty-clear" data-filter-clear>Clear all filters</button>' +
        '</div>'
      );
      $g.after($msg);
    }
    $msg.removeAttr('hidden');
  }

  function apply(){
    syncUi();

    var $g = $grid();
    if(!$g.length){ renderEmptyState(0); return; }
    var $items = $cards();
    if(!$items.length){ renderEmptyState(0); return; }

    isApplying = true;
    var visibleCount = 0;
    try {
      var sizeLc = state.size.toLowerCase();

      $items.each(function(){
        var d = this.dataset;
        var pass = true;

        if(state.stock === 'in' && parseInt(d.sortAvailable, 10) !== 1){ pass = false; }

        if(pass && sizeLc){
          var listAvail = (d.sizesAvailable || '').toLowerCase().split('|').map(function(s){ return s.trim(); }).filter(function(s){ return s; });
          var listInStock = (d.sizesInStock || '').toLowerCase().split('|').map(function(s){ return s.trim(); }).filter(function(s){ return s; });
          var hasSize = listAvail.indexOf(sizeLc) > -1;
          var hasSizeInStock = listInStock.indexOf(sizeLc) > -1;

          if(state.stock === 'in'){
            if(!hasSizeInStock){ pass = false; }
          } else {
            if(!hasSize){ pass = false; }
          }
        }
        this.style.display = pass ? '' : 'none';
        if(pass){ visibleCount++; }
      });

      var visibleIdx = 0;
      $cards().each(function(){
        var $c = $(this);
        if(this.style.display === 'none'){
          $c.removeClass('is-row-start');
          return;
        }
        if(visibleIdx % 3 === 0){ $c.addClass('is-row-start'); }
        else { $c.removeClass('is-row-start'); }
        visibleIdx++;
      });

      rewriteProductLinks();

      renderEmptyState(visibleCount);
      syncUi();
    } finally {
      setTimeout(function(){ isApplying = false; }, 200);
    }
  }

  function activeCount(){
    var n = 0;
    if(state.stock){ n++; }
    if(state.size){ n++; }
    if(state.sort && state.sort !== DEFAULT_SORT){ n++; }
    return n;
  }

  function syncUi(){
    $container.find('[data-filter-group]').each(function(){
      var $group = $(this);
      var group = $group.attr('data-filter-group');
      var current = state[group] || '';
      $group.find('[data-filter-value]').each(function(){
        var v = this.getAttribute('data-filter-value') || '';
        var active = (v === current);
        $(this).toggleClass('is-active', active)
          .attr('aria-checked', active ? 'true' : 'false')
          .attr('aria-selected', active ? 'true' : 'false');
      });
    });
    $container.find('[data-filter-trigger][data-filter-group]').each(function(){
      var $trigger = $(this);
      var group = $trigger.attr('data-filter-group');
      var current = state[group] || '';
      var $opt = $container.find('[data-filter-group="' + group + '"] [data-filter-value="' + cssEscape(current) + '"]').first();
      var label = $opt.length ? $opt.text().trim() : '';
      if(!label){
        label = $container.find('[data-filter-group="' + group + '"] [data-filter-value=""]').first().text().trim();
      }
      $trigger.find('[data-filter-value-label]').text(label);
      $trigger.toggleClass('is-active', !!current);
    });

    var $count = $container.find('[data-filter-active-count]');
    var n = activeCount();
    if(n > 0){ $count.text(n).removeAttr('hidden'); }
    else { $count.text('').attr('hidden', ''); }

    var $clear = $container.find('[data-filter-clear]');
    if(n > 0){ $clear.removeAttr('hidden'); }
    else { $clear.attr('hidden', ''); }
    syncToggleUi();
  }

  function cssEscape(s){
    return String(s).replace(/(["\\])/g, '\\$1');
  }

  function panelHost($el){
    var $dd = $el.closest('[data-filter-dropdown]');
    return $dd.length ? $dd : $el.closest('[data-filter-preview]');
  }

  function closeAllPanels(except){
    $container.each(function(){
      var $c = $(this);
      $c.find('[data-filter-dropdown]').each(function(){
        if(except && this === except){ return; }
        $(this).find('[data-filter-panel]').attr('hidden', '');
        $(this).find('[data-filter-trigger]').attr('aria-expanded', 'false');
      });
      if(!$c.find('[data-filter-dropdown]').length){
        if(except !== $c[0]){
          $c.find('[data-filter-panel]').attr('hidden', '');
          $c.find('[data-filter-trigger]').attr('aria-expanded', 'false');
        }
      }
    });
  }

  $(document).on('click', '[data-filter-preview] [data-filter-trigger]', function(evt){
    evt.preventDefault();
    evt.stopPropagation();
    var $trigger = $(this);
    var $host = panelHost($trigger);
    var $panel = $host.find('[data-filter-panel]').first();
    var isOpen = !$panel.prop('hidden');
    closeAllPanels($host[0]);
    if(isOpen){
      $panel.attr('hidden', '');
      $trigger.attr('aria-expanded', 'false');
    } else {
      $panel.removeAttr('hidden');
      $trigger.attr('aria-expanded', 'true');
    }
  });
  $(document).on('click', function(evt){
    if($(evt.target).closest('[data-filter-preview]').length){ return; }
    closeAllPanels(null);
  });
  $(document).on('keydown', function(evt){
    if(evt.key === 'Escape'){ closeAllPanels(null); }
  });

  function navigateSort(sortValue){
    var url;
    try { url = new URL(location.href); }
    catch(e){ return false; }
    var params = url.searchParams;
    if(sortValue && sortValue !== DEFAULT_SORT){ params.set(URL_PARAMS.sort, sortValue); }
    else { params.delete(URL_PARAMS.sort); }
    var native = FILTER_TO_NATIVE.hasOwnProperty(sortValue) ? FILTER_TO_NATIVE[sortValue] : '';
    if(native){ params.set(NATIVE_SORT_PARAM, native); }
    else { params.delete(NATIVE_SORT_PARAM); }
    params.delete('page');

    location.assign(url.toString());
    return true;
  }
  $(document).on('click', '[data-filter-preview] [data-filter-value]', function(evt){
    evt.preventDefault();
    var $btn = $(this);
    var group = $btn.closest('[data-filter-group]').attr('data-filter-group');
    if(!group){ return; }
    var value = $btn.attr('data-filter-value') || '';

    if(group === 'sort'){
      state.sort = value;
      syncUi();
      navigateSort(value);
      return;
    }

    state[group] = value;
    writeStateToUrl();
    apply();
    var $dd = $btn.closest('[data-filter-dropdown]');
    if($dd.length){
      $dd.find('[data-filter-panel]').attr('hidden', '');
      $dd.find('[data-filter-trigger]').attr('aria-expanded', 'false');
    }
  });
  function syncToggleUi(){
    $container.find('[data-filter-toggle-input]').each(function(){
      this.checked = (state.stock === 'in');
    });
  }
  $(document).on('change', '[data-filter-preview] [data-filter-toggle-input]', function(){
    state.stock = this.checked ? 'in' : '';
    writeStateToUrl();
    apply();
  });

  $(document).on('click', '[data-filter-preview] [data-filter-clear]', function(evt){
    evt.preventDefault();

    if(readParam(NATIVE_SORT_PARAM)){
      var url;
      try { url = new URL(location.href); } catch(e){ url = null; }
      if(url){
        [NATIVE_SORT_PARAM, URL_PARAMS.sort, URL_PARAMS.size, URL_PARAMS.stock, 'page'].forEach(function(p){
          url.searchParams.delete(p);
        });
        location.assign(url.toString());
        return;
      }
    }
    state = { stock: '', size: '', sort: DEFAULT_SORT };
    writeStateToUrl();
    syncToggleUi();
    apply();
  });

  function observeGrid(){
    var container = document.querySelector('[data-ajax-products]');
    if(!container || !window.MutationObserver){ return; }
    var debounce = null;
    var lastCardCount = $cards().length;
    var observer = new MutationObserver(function(records){
      if(isApplying){ return; }

      var hasRealChange = false;
      for(var i = 0; i < records.length; i++){
        if(records[i].addedNodes.length || records[i].removedNodes.length){
          hasRealChange = true;
          break;
        }
      }
      if(!hasRealChange){ return; }
      clearTimeout(debounce);
      debounce = setTimeout(function(){
        var nowCount = $cards().length;
        if(nowCount !== lastCardCount){
          lastCardCount = nowCount;
          populateSizeOptions();
          apply();
        }
      }, 50);
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  function markWrapper(){
    $('.collection-product-list').addClass('has-client-filter');
  }
  function rewriteProductLinks(){
    $('.product-block a[href]').each(function(){
      var href = this.getAttribute('href');
      if(!href || href.charAt(0) === '#'){ return; }
      if(href.indexOf('/products/') === -1){ return; }
      href = href.replace(/([?&])filter_size=[^&]*(&|$)/g, function(_, lead, trail){
        return trail === '&' ? lead : (lead === '?' ? '' : '');
      });
      if(state.size){
        var sep = href.indexOf('?') > -1 ? '&' : '?';
        href = href + sep + 'filter_size=' + encodeURIComponent(state.size);
      }
      this.setAttribute('href', href);
    });
  }

  $(document).ready(function(){
    markWrapper();
    populateSizeOptions();
    hydrateStateFromUrl();
    apply();
    observeGrid();
  });

  $(document).on('ajax-pagination:swapped', function(){
    markWrapper(); 
    populateSizeOptions();
    apply();
  });
})();

(function ajaxPaginationInit(){
  var PAGINATION_WRAPPER = '.collection-product-list';
  var $body = $('html, body');
  var inFlight = false;
  var hasPushed = false;

  function findScrollTarget(){

    var candidates = [
      '[data-filter-preview]',
      '[data-applied-filters]:not([hidden])',
      '.collection-toolbar',
      '.collection-product-list'
    ];
    for(var i = 0; i < candidates.length; i++){
      var $el = $(candidates[i]).first();
      if($el.length && $el.is(':visible')){
        return Math.max(0, $el.offset().top - 80);
      }
    }
    return 0;
  }

  function swap(url, options){
    options = options || {};
    if(inFlight){ return; }
    var $wrapper = $(PAGINATION_WRAPPER).first();
    if(!$wrapper.length){
      window.location = url;
      return;
    }

    inFlight = true;
    var prevTransition = $wrapper.css('transition');
    $wrapper.css({
      transition: 'opacity 200ms ease',
      opacity: 0.35,
      pointerEvents: 'none'
    });

    $.get(url).done(function(html){
      var $doc = $('<div>').append($.parseHTML(html));
      var $newWrapper = $doc.find(PAGINATION_WRAPPER).first();

      if($newWrapper.length){
        $wrapper.html($newWrapper.html());
      }

      $wrapper.css({
        transition: prevTransition || '',
        opacity: '',
        pointerEvents: ''
      });

      var newTitle = $doc.find('title').first().text();
      if(newTitle){ document.title = newTitle; }

      if(!options.skipPushState){
        window.history.pushState({ ajaxPagination: true }, newTitle || document.title, url);
        hasPushed = true;
      }

      $(document).trigger('ajax-pagination:swapped', { url: url });
      if(!options.skipScroll){
        var target = findScrollTarget();
        $body.stop(true).animate({ scrollTop: target }, 500);
      }
    }).fail(function(){
      window.location = url;
    }).always(function(){
      inFlight = false;
    });
  }
  $(document).on('click', '.pagination a[href]', function(evt){
    if(evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey || evt.which === 2){ return; }
    var href = this.getAttribute('href');
    if(!href || href.charAt(0) === '#'){ return; }
    var a = document.createElement('a');
    a.href = href;
    if(a.host && a.host !== location.host){ return; }
    evt.preventDefault();
    swap(href);
  });

  $(window).on('popstate.ajaxPagination', function(evt){
    var state = evt.originalEvent && evt.originalEvent.state;
    if(state && state.ajaxPagination){
      swap(location.href, { skipPushState: true, skipScroll: true });
    } else if(hasPushed){
      swap(location.href, { skipPushState: true, skipScroll: true });
    }
  });
})();

(function autoSelectFilteredSizeOnPDP(){
  if(!document.querySelector('[data-product-json]')){ return; }

  function readParam(name){
    if(!location.search){ return ''; }
    var pairs = location.search.substr(1).split('&');
    for(var i = 0; i < pairs.length; i++){
      var p = pairs[i].split('=');
      if(decodeURIComponent(p[0]) === name){
        return decodeURIComponent((p[1] || '').replace(/\+/g, ' '));
      }
    }
    return '';
  }

  var targetSize = readParam('filter_size');
  if(!targetSize){ return; }
  var targetLc = targetSize.trim().toLowerCase();

  $(document).ready(function(){
    setTimeout(function(){
      var $selectors = $('[data-single-option-selector]');
      if(!$selectors.length){ return; }

      var $sizeSelector = null;
      $selectors.each(function(){
        var $sel = $(this);
        var label = ($('label[for="' + $sel.attr('id') + '"]').text() || '').trim().toLowerCase();
        if(/^size\b/.test(label)){
          $sizeSelector = $sel;
          return false;
        }
      });

      var $candidates = $sizeSelector ? $sizeSelector : $selectors;
      $candidates.each(function(){
        var $sel = $(this);
        var $opt = $sel.find('option').filter(function(){
          return (this.value || '').trim().toLowerCase() === targetLc;
        }).first();
        if(!$opt.length){ return; }
        // Skip if it's already the selected option — triggering change
        // would be a no-op and may double-fire select2 redraws.
        if($sel.val() === $opt.attr('value')){ return false; }
        $sel.val($opt.attr('value'));
        $sel.trigger('change');
        // Nudge select2 if the theme wrapped this select with it, so the
        // visible chrome updates to match the new value.
        if($sel.data('select2')){ $sel.trigger('change.select2'); }
        return false;
      });
    }, 0);
  });
})();

(function mobileHeaderUI() {

  var nav = document.getElementById('MobileNav');
  var searchPanel = document.getElementById('MobileSearchPanel');
  if (!nav && !searchPanel) { return; }

  var navToggleBtn = document.querySelector('.js-mobile-nav-toggle');
  var searchToggleBtn = document.querySelector('.js-mobile-search-toggle');
  var searchInput = searchPanel ? searchPanel.querySelector('.mobile-search-panel__input') : null;
  var $ = window.jQuery;
  var slideMs = 250;

  // The zero-height anchor the panel is absolutely positioned inside; it sits
  // directly under the mobile header bar, so its top is where the panel starts.
  var navWrap = nav ? (nav.closest ? nav.closest('.mobile-header-nav-wrap') : nav.parentNode) : null;
  if (!navWrap) { navWrap = nav ? nav.parentNode : null; }

  function navIsOpen() {
    return !!nav && nav.classList.contains('is-open');
  }


  // visualViewport is the area the user can actually see: it excludes the
  // browser's own toolbars, which window.innerHeight does not.
  function viewportBox() {
    var vv = window.visualViewport;
    if (vv && vv.height) { return { height: vv.height, offsetTop: vv.offsetTop || 0 }; }
    return { height: window.innerHeight || 0, offsetTop: 0 };
  }

  // available height = viewport - (announcement bar + header bar)
  //
  // navWrap is the zero-height anchor the panel is positioned inside, so its
  // top IS the combined height of everything rendered above the panel - no
  // per-bar measuring, and it stays correct if a bar is added, removed or
  // changes height. Written to --mobile-nav-height, consumed by predictive.css.
  function syncNavHeight() {
    if (!nav || !navWrap || !navWrap.getBoundingClientRect) { return; }
    var box = viewportBox();
    // getBoundingClientRect is relative to the layout viewport; subtracting
    // offsetTop expresses it against the visual viewport instead.
    var top = navWrap.getBoundingClientRect().top - box.offsetTop;
    var height = Math.round(box.height - top);
    if (height > 0) { nav.style.setProperty('--mobile-nav-height', height + 'px'); }
  }

  // The CSS lock (html.mobile-nav-open) stops wheel and keyboard scrolling, but
  // a touch drag can still move the page on iOS Safari. This lets a drag that
  // started inside the panel scroll the panel, and cancels every other one.
  // Bound only while the menu is open, so it costs nothing the rest of the time.
  function blockPageTouch(e) {
    if (nav && nav.contains(e.target)) { return; }
    if (e.cancelable) { e.preventDefault(); }
  }

  function lockPageScroll(lock) {
    var root = document.documentElement;
    if (!root) { return; }
    if (lock) {
      root.classList.add('mobile-nav-open');
      document.addEventListener('touchmove', blockPageTouch, { passive: false });
    } else {
      root.classList.remove('mobile-nav-open');
      document.removeEventListener('touchmove', blockPageTouch, { passive: false });
    }
  }

  function openNav() {
    if (!nav) { return; }
    syncNavHeight(); // measure before the page is held, while the bar renders
    nav.classList.add('is-open');
    if ($) {
      // slideDown animates an inline height and sets overflow:hidden for the
      // duration. If a slide is ever cut short those linger, which freezes the
      // panel at a stale height with its scrolling switched off - so clear them
      // once it settles and let the stylesheet own the box again.
      $(nav).stop(true, true).slideDown(slideMs, function () {
        nav.style.removeProperty('height');
        nav.style.removeProperty('overflow');
      });
    } else { nav.style.display = 'block'; }
    lockPageScroll(true);
    if (navToggleBtn) {
      navToggleBtn.setAttribute('aria-expanded', 'true');
      navToggleBtn.setAttribute('aria-label', 'Close menu');
    }
  }

  function closeNav() {
    if (!nav) { return; }
    nav.classList.remove('is-open');
    if ($) { $(nav).stop(true, true).slideUp(slideMs); }
    else { nav.style.display = 'none'; }
    lockPageScroll(false);
    if (navToggleBtn) {
      navToggleBtn.setAttribute('aria-expanded', 'false');
      navToggleBtn.setAttribute('aria-label', 'Open menu');
    }
  }

  function toggleNav() {
    if (navIsOpen()) { closeNav(); } else { openNav(); }
  }

  function openSearch() {
    if (!searchPanel) { return; }
    searchPanel.classList.add('is-open');
    searchPanel.setAttribute('aria-hidden', 'false');
    if (searchToggleBtn) { searchToggleBtn.setAttribute('aria-expanded', 'true'); }
    setTimeout(function () {
      if (searchInput) { try { searchInput.focus(); } catch (_) {} }
    }, 60);
  }

  function closeSearch() {
    if (!searchPanel) { return; }
    searchPanel.classList.remove('is-open');
    searchPanel.setAttribute('aria-hidden', 'true');
    if (searchToggleBtn) { searchToggleBtn.setAttribute('aria-expanded', 'false'); }
    // Hand focus back to the toggle rather than blurring: blur() drops focus on
    // <body>, so Tab / Shift+Tab restart from the top of the document.
    if (searchPanel.contains(document.activeElement)) {
      if (searchToggleBtn) { try { searchToggleBtn.focus(); } catch (_) {} }
      else if (searchInput) { try { searchInput.blur(); } catch (_) {} }
    }
  }

  function toggleSearch() {
    if (!searchPanel) { return; }
    if (searchPanel.classList.contains('is-open')) { closeSearch(); } else { openSearch(); }
  }

  document.addEventListener('click', function (evt) {
    var t = evt.target.closest ? evt.target.closest(
      '.js-mobile-nav-toggle, .js-mobile-search-toggle, .js-mobile-search-close'
    ) : null;
    if (!t) { return; }
    if (t.matches('.js-mobile-nav-toggle')) {
      evt.preventDefault();
      closeSearch();
      toggleNav();
    } else if (t.matches('.js-mobile-search-toggle')) {
      evt.preventDefault();
      toggleSearch();
    } else if (t.matches('.js-mobile-search-close')) {
      evt.preventDefault();
      closeSearch();
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape' && evt.keyCode !== 27) { return; }
    if (searchPanel && searchPanel.classList.contains('is-open')) { closeSearch(); }
    else if (navIsOpen()) {
      closeNav();
      if (navToggleBtn) { try { navToggleBtn.focus(); } catch (_) {} }
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 750) {
      if (navIsOpen()) { closeNav(); }
      if (searchPanel && searchPanel.classList.contains('is-open')) { closeSearch(); }
    } else if (navIsOpen()) {
      syncNavHeight();
    }
  });

  window.addEventListener('orientationchange', function () {
    if (navIsOpen()) { setTimeout(syncNavHeight, 100); }
  });

  function resyncIfOpen() { if (navIsOpen()) { syncNavHeight(); } }

  // Mobile browsers change the visible area without a window resize when their
  // toolbars slide in and out, and offset it when the page is pinch-zoomed.
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', resyncIfOpen);
    window.visualViewport.addEventListener('scroll', resyncIfOpen);
  }

  // The announcement bar and header bar sit above the panel, so anything that
  // changes their height (message carousel, a bar being shown or hidden) moves
  // where the panel starts. Watching the header covers all of them at once.
  if (window.ResizeObserver && nav && nav.closest) {
    var siteHeader = nav.closest('.site-header');
    if (siteHeader) { new window.ResizeObserver(resyncIfOpen).observe(siteHeader); }
  }
})();
